const data = {
  currentPage: 1,
  searchArray: [],
  searchObject: {},
  searchDate: '',
  searchFrom: '',
  searchTerm: '',
  searchTo: '',
  sortBy: '',
  sortDirection: '',
  total: 0
}

export default {
  namespaced: true,
  strict: process.env.NODE_ENV === 'development',
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Set the current page of the pagination.
     * @param {*} state
     * @param {*} currentPage
     */
    setCurrentPage (state, currentPage) {
      state.currentPage = currentPage
    },

    /**
     * Set the search array for the pagination.
     * @param {*} state
     * @param {*} searchArray
     */
    setSearchArray (state, searchArray) {
      state.searchArray = searchArray
    },

    /**
     * Set the search object for the pagination.
     * @param {*} state
     * @param {*} searchObject
     */
    setSearchObject (state, searchObject) {
      state.searchObject = searchObject
    },

    /**
     * Set the search date for the pagination.
     * @param {*} state
     * @param {*} searchDate
     */
    setSearchDate (state, searchDate) {
      state.searchDate = searchDate
    },

    /**
     * Set the search date for the pagination.
     * @param {*} state
     * @param {*} searchFrom
     */
    setSearchFrom (state, searchFrom) {
      state.searchFrom = searchFrom
    },

    /**
     * Set the search term for the pagination.
     * @param {*} state
     * @param {*} searchTerm
     */
    setSearchTerm (state, searchTerm) {
      state.searchTerm = searchTerm
    },

    /**
     * Set the search date for the pagination.
     * @param {*} state
     * @param {*} searchTo
     */
    setSearchTo (state, searchTo) {
      state.searchTo = searchTo
    },

    /**
     * Set the sort by column of the pagination.
     * @param {*} state
     * @param {*} sortBy
     */
    setSortBy (state, sortBy) {
      state.sortBy = sortBy
    },

    /**
     * Set the sort direction of the pagination.
     * @param {*} state
     * @param {*} sortDirection
     */
    setSortDirection (state, sortDirection) {
      state.sortDirection = sortDirection
    },

    /**
     * Set the total items of the pagination.
     * @param {*} state
     * @param {*} total
     */
    setTotal (state, total) {
      state.total = total
    },

    /**
     * Reset all state.
     * @param {*} state
     */
    reset (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    }
  }
}
